<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column">
            <h1 class="title is-size-4 has-text-centered">รายชื่อห้องปฏิบัติการ/คลินิกเทคนิคการแพทย์ที่เปิดให้บริการตรวจด้วย</h1>
            <h1 class="title has-text-centered">Antigen Test Kit</h1>
            <h1 class="subtitle is-size-5 has-text-centered">รวบรวมโดยสภาเทคนิคการแพทย์</h1>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
            <b-table :data="data" :striped="true" :paginated="true" :per-page="10" v-if="data.length > 0">
              <b-table-column field="name" label="ห้องปฏิบัติการ" :sortable="true">
                <template v-slot="props">
                  {{ props.row.name }}
                </template>
              </b-table-column>
              <b-table-column field="address" label="ที่อยู่" :sortable="false">
                <template v-slot="props">
                  {{ props.row.address }}
                </template>
              </b-table-column>
              <b-table-column field="district" label="อำเภอ" :sortable="true">
                <template v-slot="props">
                  {{ props.row.district }}
                </template>
              </b-table-column>
              <b-table-column field="province" label="จังหวัด" :sortable="true">
                <template v-slot="props">
                  {{ props.row.province }}
                </template>
              </b-table-column>
              <b-table-column field="tel" label="โทรศัพท์" :sortable="false">
                <template v-slot="props">
                  {{ props.row.tel }}
                </template>
              </b-table-column>
              <b-table-column field="line" label="ไลน์" :sortable="false">
                <template v-slot="props">
                  {{ props.row.line }}
                </template>
              </b-table-column>
              <b-table-column field="facebook" label="เฟสบุค" :sortable="false">
                <template v-slot="props">
                  {{ props.row.facebook }}
                </template>
              </b-table-column>
              <b-table-column field="serviceCharge" label="อัตราค่าบริการ" :sortable="false">
                <template v-slot="props">
                  {{ props.row.serviceCharge }}
                </template>
              </b-table-column>
              <b-table-column field="officeHour" label="เวลาทำงาน" :sortable="false">
                <template v-slot="props">
                  {{ props.row.officeHour }}
                </template>
              </b-table-column>
              <b-table-column>
                <template v-slot="props">
                  <router-link :to="{ name: 'AdminLabEdit', params: { labId: props.row.id }}">
                    Edit
                  </router-link>
                </template>
              </b-table-column>
            </b-table>
          </div>
        </div>
        <div class="buttons is-centered">
          <router-link class="button is-light"
                       :to="{ name: 'LabDistrict', params: { province: $route.params.province }}">กลับ</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {db} from '../firebase'
export default {
  name: "Lab",
  data () {
    return {
      isLoading: true,
      data: [],
      province: '',
      district: '',
    }
  },
  mounted() {
    const self = this
    db.collection('labs').get().then(snapshot=>{
      snapshot.docs.forEach(d=>{
        let datum = d.data()
        datum.id = d.id
        self.data.push(datum)
      })
      self.isLoading = false
    })
  }
}
</script>

<style scoped>

</style>
